import React, { useEffect, useState } from 'react';
import { Navbar, Nav, NavDropdown } from 'react-bootstrap';
import { Link, Route, Switch, useHistory, useLocation } from 'react-router-dom';
import PromotionProducts from './PromotionProducts/PromotionProducts';
import PromotionTerms from './PromotionTerms/PromotionTerms';
import PromotionOrders from './PromotionOrders/PromotionOrders';
import ManageTraders from './ManageTraders/ManageTraders';
import TraderRegistration from './TraderRegistration/TraderRegistration';
import RooferRegistration from './RooferRegistration/RooferRegistration';
import TermsAcceptation from './TermsAcceptation/TermsAcceptation';
import PromotionRegulations from './PromotionRegulations/PromotionRegulations';
import LinkItem from 'components/LinkItem';
import { useUser } from 'reducers';
import { FaAngleDown, FaAngleRight } from 'react-icons/fa';
import permissionService from 'services';
import _ from 'lodash';
import { useDevice } from 'lib/hooks/useDevice';

type DropdownItem = {
    isVisible?: boolean,
    linkTo: string,
    title:string,
};

type RouteData = {
    isVisible?: boolean,
    route: string,
    component: JSX.Element,
};

const Promotions = () => {
    const location = useLocation();
    const { isMedium, isDesktop } = useDevice();
    const user = useUser();
    const [activeKey, setActiveKey] = useState('accept-terms');
    const history = useHistory();
    const areRulesAccepted = user?.promotionTermsAccept !== '19010101' && user?.promotionalProgramEnroll !== '19010101';

    const [showUsersDropdown, setShowUsersDropdown] = useState(false);
    const [showTermsDropdown, setShowTermsDropdown] = useState(false);

    const notRestrictedPaths = [
        `${process.env.PUBLIC_URL}/promotions/accept-terms`,
        `${process.env.PUBLIC_URL}/promotions/promotion-regulations`
    ];

    useEffect(() => {
        if (!notRestrictedPaths.includes(location.pathname) && !areRulesAccepted) {
            history.replace(`${process.env.PUBLIC_URL}/promotions/accept-terms`);
        } else if (location.pathname === `${process.env.PUBLIC_URL}/promotions`) {
            history.replace(`${process.env.PUBLIC_URL}/promotions/articles`);
        }

        if (location.pathname.includes(`${process.env.PUBLIC_URL}/promotions/terms`)) {
            setActiveKey('terms');
        } else if (location.pathname.includes(`${process.env.PUBLIC_URL}/promotions/orders`)) {
            setActiveKey('orders');
        } else if (location.pathname.includes(`${process.env.PUBLIC_URL}/promotions/register-roofer`)) {
            setActiveKey('register-roofer');
        } else if (location.pathname.includes(`${process.env.PUBLIC_URL}/promotions/register-trader`)) {
            setActiveKey('register-trader');
        } else if (location.pathname.includes(`${process.env.PUBLIC_URL}/promotions/manage-traders`)) {
            setActiveKey('manage-traders');
        } else if (location.pathname.includes(`${process.env.PUBLIC_URL}/promotions/articles`)) {
            setActiveKey('articles');
        } else if (location.pathname.includes(`${process.env.PUBLIC_URL}/promotions/promotion-regulations`)) {
            setActiveKey('promotion-regulations');
        } else if (location.pathname.includes(`${process.env.PUBLIC_URL}/promotions/accept-terms`)) {
            setActiveKey('accept-terms');
        }

        if (areRulesAccepted && activeKey === 'accept-terms' && location.pathname.includes(`${process.env.PUBLIC_URL}/promotions/accept-terms`)) {
            setActiveKey('articles');
        }
    }, [location.pathname]);

    const usersDropdownItems : DropdownItem[] = [
        {
            linkTo: 'register-roofer',
            title: 'Rejestruj dekarza'
        },
        {
            isVisible: permissionService.haveAccessToView('register-trader'),
            linkTo: 'register-trader',
            title: 'Rejestruj handlowca'
        },
        {
            isVisible: permissionService.haveAccessToView('manage-traders'),
            linkTo: 'manage-traders',
            title: 'Administracja handlowcami'
        }
    ];

    const showTermsDropdownItems : DropdownItem[] = [
        {
            linkTo: 'terms',
            title: 'Regulamin'
        },
        {
            linkTo: 'promotion-regulations',
            title: 'Zasady działania programu promocyjnego'
        }
    ];

    const dropdownItemFactory = ({ isVisible = true, linkTo, title } : DropdownItem) => {
        if (!isVisible) return null;

        return (
            <NavDropdown.Item
                key={linkTo}
                eventKey={linkTo}
                className={location.pathname === `${process.env.PUBLIC_URL}/promotions/${linkTo}` ? 'promotions-submenu-active' : ''}
                as={Link}
                to={`${process.env.PUBLIC_URL}/promotions/${linkTo}`}
            >
                {title}
            </NavDropdown.Item>
        );
    };

    const routes : RouteData[] = [
        { route: 'articles', component: <PromotionProducts /> },
        { route: 'terms', component: <PromotionTerms /> },
        { route: 'accept-terms', component: <TermsAcceptation /> },
        { route: 'promotion-regulations', component: <PromotionRegulations /> },
        { route: 'orders/:page', component: <PromotionOrders /> },
        { route: 'orders', component: <PromotionOrders /> },
        {
            isVisible: permissionService.haveAccessToView('register-roofer'),
            route: 'register-roofer',
            component: <RooferRegistration />
        },
        {
            isVisible: permissionService.haveAccessToView('register-trader'),
            route: 'register-trader',
            component: <TraderRegistration />
        },
        {
            isVisible: permissionService.haveAccessToView('manage-traders'),
            route: 'manage-traders',
            component: <ManageTraders />
        }
    ];

    return (
        <>
            {isMedium && (
                <Navbar className='sub-navbar' expand='lg'>
                    {user?.promotionTermsAccept !== '19010101' && user?.promotionalProgramEnroll !== '19010101' ? (
                        <Nav
                            justify
                            variant='pills'
                            className='flex-grow-1 flex-shrink-1'
                            activeKey={activeKey}
                        >
                            <LinkItem to={`${process.env.PUBLIC_URL}/promotions/articles`} eventKey='articles'>Artykuły promocyjne</LinkItem>
                            <LinkItem to={`${process.env.PUBLIC_URL}/promotions/orders`} eventKey='orders'>Zamówienia na artykuły promocyjne</LinkItem>
                            {permissionService.haveAccessToView('register-roofer') &&
                                <NavDropdown
                                    renderMenuOnMount
                                    title={<div className='promotion-submenu-dropdown-title'>Użytkownicy <div className='angle'>{showUsersDropdown ? <FaAngleDown /> : <FaAngleRight />}</div></div>}
                                    id='promotion-users-dropdown'
                                    className={`promotion-submenu-dropdown ${!isDesktop ? 'submenu-dropdown-medium' : ''}`}
                                    show={showUsersDropdown}
                                    onMouseEnter={isDesktop ? () => setShowUsersDropdown(true) : () => { }}
                                    onMouseLeave={isDesktop ? () => setShowUsersDropdown(false) : () => { }}
                                    onClick={isDesktop ? () => setShowUsersDropdown(false) : () => { setShowUsersDropdown(!showUsersDropdown); }}
                                >
                                    {_.map(usersDropdownItems, (di) => dropdownItemFactory(di))}
                                </NavDropdown>}
                            <NavDropdown
                                renderMenuOnMount
                                title={<div className='promotion-submenu-dropdown-title'>Jak to działa? <div className='angle'>{showTermsDropdown ? <FaAngleDown /> : <FaAngleRight />}</div></div>}
                                id='promotion-users-dropdown'
                                className={`promotion-submenu-dropdown ${!isDesktop ? 'submenu-dropdown-medium' : ''}`}
                                show={showTermsDropdown}
                                onMouseEnter={isDesktop ? () => setShowTermsDropdown(true) : () => { }}
                                onMouseLeave={isDesktop ? () => setShowTermsDropdown(false) : () => { }}
                                onClick={isDesktop ? () => setShowTermsDropdown(false) : () => { setShowTermsDropdown(!showTermsDropdown); }}
                            >
                                {_.map(showTermsDropdownItems, (di) => dropdownItemFactory(di))}
                            </NavDropdown>
                        </Nav>
                    ) : (
                        <Nav
                            justify
                            variant='pills'
                            className='flex-grow-1 flex-shrink-1'
                            activeKey={activeKey}
                        >
                            <LinkItem to={`${process.env.PUBLIC_URL}/promotions/accept-terms`} eventKey='accept-terms'>Akceptacja Regulaminu</LinkItem>
                            <LinkItem to={`${process.env.PUBLIC_URL}/promotions/promotion-regulations`} eventKey='promotion-regulations'>Zasady działania programu promocyjnego</LinkItem>
                        </Nav>
                    )}
                </Navbar>
            )}
            <Switch>
                {_.map(routes, ({ isVisible = true, route, component } : RouteData) => {
                    if (!isVisible) return null;
                    return (
                        <Route key={route} path={`${process.env.PUBLIC_URL}/promotions/${route}`}>
                            {component}
                        </Route>
                    );
                })}
                {areRulesAccepted ?
                    <Route>
                        <PromotionProducts />
                    </Route> :
                    <Route>
                        <TermsAcceptation />
                    </Route>}
            </Switch>
        </>
    );
};

export default Promotions;
